import { Injectable } from '@angular/core';

/**
 * ToastService propio del proyecto (reemplaza el de ng-uikit-pro-standard).
 * Usa DevExtreme notify() por debajo — misma API (success/error/info/warning/clear)
 * para que todas las llamadas existentes this.toast.* sigan funcionando.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  success(message: string, title?: string, options?: any): void {
    this.notify(message, title, 'success');
  }

  error(message: string, title?: string, options?: any): void {
    this.notify(message, title, 'error');
  }

  info(message: string, title?: string, options?: any): void {
    this.notify(message, title, 'info');
  }

  warning(message: string, title?: string, options?: any): void {
    this.notify(message, title, 'warning');
  }

  clear(): void { /* DevExtreme toasts se auto-cierran */ }

  // Tarjeta blanca (icono de color por tipo + titulo + mensaje + cerrar + barra de tiempo) en vez
  // del rectangulo de color plano de DevExtreme. El estilo es global en styles.scss (.cst-*).
  private static readonly KINDS: any = {
    success: { icon: 'fa-check', title: 'Done' },
    error: { icon: 'fa-times', title: 'Something went wrong' },
    warning: { icon: 'fa-exclamation', title: 'Heads up' },
    info: { icon: 'fa-info', title: 'For your information' },
  };

  private notify(message: string, title: string | undefined, type: string): void {
    const kind = ToastService.KINDS[type] || ToastService.KINDS.info;
    const displayTime = type === 'error' ? 6000 : 4000;   // los errores se leen con mas calma
    import('devextreme/ui/notify').then(m => {
      const notify = (m as any).default || m;
      notify(
        {
          type,
          displayTime,
          width: 'auto',
          maxWidth: 420,
          shading: false,
          closeOnClick: true,
          position: { my: 'top right', at: 'top right', of: window, offset: '-20 70' },
          animation: {
            show: { type: 'slide', duration: 220, from: { opacity: 0, left: '+=24' }, to: { opacity: 1 } },
            hide: { type: 'fade', duration: 180, to: 0 },
          },
          // el texto va por textContent: nunca se interpreta como HTML
          contentTemplate: (el: any) => {
            const host: HTMLElement = el && el.get ? el.get(0) : el;
            const root = document.createElement('div');
            root.className = 'cst cst--' + type;
            root.setAttribute('role', type === 'error' ? 'alert' : 'status');

            const icon = document.createElement('span');
            icon.className = 'cst-icon';
            icon.innerHTML = '<i class="fas ' + kind.icon + '"></i>';

            const body = document.createElement('div');
            body.className = 'cst-body';
            const head = document.createElement('b');
            head.className = 'cst-title';
            head.textContent = title || kind.title;
            const msg = document.createElement('span');
            msg.className = 'cst-msg';
            msg.textContent = message == null ? '' : String(message);
            body.appendChild(head);
            if (msg.textContent) { body.appendChild(msg); }

            const close = document.createElement('button');
            close.type = 'button';
            close.className = 'cst-close';
            close.setAttribute('aria-label', 'Dismiss');
            close.innerHTML = '<i class="fas fa-times"></i>';

            const bar = document.createElement('span');
            bar.className = 'cst-bar';
            bar.style.animationDuration = displayTime + 'ms';

            root.appendChild(icon);
            root.appendChild(body);
            root.appendChild(close);
            root.appendChild(bar);
            host.appendChild(root);
          },
        },
      );
    });
  }
}
